module.exports = __webpack_public_path__ + "img/tema-1-9.72a479e0.svg";